<template>
  <v-card flat>
    <v-card-text>
      <v-select
        :items="items"
        v-model="selected"
        item-value="id"
        item-text="datetime"
        label="Select a combat test"
        filled
      />
      <template v-if="loading">
        <div class="text-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          />
        </div>
      </template>
      <template v-else-if="selected">
        <iframe
          ref="iframe"
          title="Combat Test Page"
          width="100%"
          :src="src"
        />
      </template>
      <template v-else>
         <div class="text-center">
          No selected Combat Test
         </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      items: [],
      selected: null
    };
  },
  computed: {
    src () {
      return `api/static/combat-tests.html?project=${this.$store.state.currProject.db}&page_id=${this.selected}`
    }
  },
  async mounted () {
    await this.fetchCombatTestList()


    const main = document.querySelector('main');
    if (main) {
      const header = document.querySelector('header');
      if (header) {
         const height = main.offsetHeight - header.offsetHeight;
         this.$refs.iframe.style.height = `${height - 16 * 2}px`;
      }
    }
  },
  methods: {
    async fetchCombatTestList () {
      this.loading = true

      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/combat-test/list')
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.items = data
        if (!this.selected) {
          this.selected = data[0] && data[0].id || null
        }
      }

      this.loading = false
    }
  },
}
</script>

<style scoped>
  iframe {
    width: 100%;
    border: none;
  }
</style>